module.exports = {
  eventCategory: 'Editor UI | Tool Menu | customize | placeholders',

  render: function () {
    this.trackEvent({
      eventAction: 'show',
      eventLabel: this.categoryKey
    });
  }
};
